module.exports = __webpack_public_path__ + "img/dashboard-logo.f505989e.png";